<template lang="pug">
v-card
  v-card-title.d-flex.justify-center(style='color:#222222; font-weight: 700; font-size: 20px;') {{$t('ADD_KNOWLEDGE_FOLDER.TITLE')}}
  v-card-text
    v-form(v-model="valid", ref="form")
      //- Folder Name
      v-row.mt-2
        v-col.pa-0(cols='3').d-flex.justify-start
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('ADD_KNOWLEDGE_FOLDER.NAME')}}
        v-col.pa-0(cols='9')
          v-text-field(
            v-model='addFolderData.name'
            outlined
            dense
            :rules='formRule.nameRules'
            required='required'
          )
      //- Parent
      v-row
        v-col.pa-0(cols='3').d-flex.justify-start
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('ADD_KNOWLEDGE_FOLDER.PATH')}}
        v-col.pa-0(cols='8')
          v-text-field(
            v-model='addFolderData.path'
            outlined
            dense
            :rules='formRule.parentRules'
            required='required'
            readonly
            @click='openFolderPick'
          )
        v-col.pa-0(cols='1')
          v-btn.pa-0(plain ripple style='width:40px; height:28px;' @click='openFolderPick')
            v-img.mr-1(src="@/assets/images/folder-btn.svg" max-height="30" max-width="30")
  //- Footer
  div.d-flex.align-center.justify-end(style='background-color: #f4f4f4;  height:60px;')
    v-btn.mr-4(
      :ripple="false"
      @click="onCancel"
      width="100"
      height="40"
      color="cancel"
      depressed
      outlined
      style='font-weight: 700;'
      :disabled="addBtn_loading"
    ) {{$t('GENERAL.CANCEL')}}
    v-btn.mr-6(
      :ripple="false"
      @click="onConfirm"
      width="100"
      height="40"
      color="#14C6DE"
      depressed
      dark
      :disabled="addBtn_loading"
    )
      v-progress-circular(v-if='addBtn_loading' indeterminate size='20')
      .t-white(v-else style='font-weight: 700;') {{$t('GENERAL.ADD')}}
  //- status dialogs
  v-dialog(v-model='messageDialog' width='360' content-class='statusDialog' v-if='messageDialog')
    message-dialog(@emitMessageDialog='onEmitMessageDialog' :message='message')
  v-dialog(v-model='errorDialog' width='360' content-class='statusDialog' @keydown.esc='onEmitErrorDialog(false)' @keydown.enter='onEmitErrorDialog(true)')
    error-dialog(@emitErrorDialog='onEmitErrorDialog' :errorMessage='errorMessage')
  v-dialog(v-model='folderPickerDialog' width='680' @keydown.esc="onCancel" content-class='statusDialog' v-if='folderPickerDialog')
    folder-location-picker-dialog(:selected-id='addFolderData.parent_id' @confirm='onFolderPickerConfirm' @cancel='onFolderPickerCancel' v-model='folderPickerDialog')
</template>
<script>
import Vue from "vue";
import messageDialog from "@/components/Dialog/redirectDialog";
import errorDialog from "@/components/Dialog/errorDialog";
import i18n from "/common/plugins/vue-i18n.js";
import folderLocationPickerDialog from "@/components/GPT_Dialog/Knowledge/folderLocationPickerDialog";
// import PersonalSettingService from "@/services/PersonalSettingService";

export default Vue.extend({
  name: "addKnowledgeFolder",
  components: {
    messageDialog,
    errorDialog,
    folderLocationPickerDialog,
  },
  props: {
    parentPath:{
      type: String,
      default: "/",
    },
    parentFolder: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      valid: true,
      addBtn_loading: false,
      addFolderData: {
        name: "",
        path: this.parentPath,
        parent_id: this.parentFolder,
        parent_folder: this.parentFolder,
      },
      formRule: {
        nameRules: [
                (v) => !!v || i18n.t('RULE.RULE_R'),
                (v) => /^.{0,100}$/.test(v) || i18n.t('RULE.RULE_100'),
        ],
        parentRules: [
                (v) => !!v || i18n.t('RULE.RULE_R'),
        ],
        system_nameRules: [
          (v) => !!v || i18n.t('RULE.RULE_R') , // 必填
          (v) => /^[a-zA-Z0-9_]+$/.test(v) || i18n.t('RULE.RULE_ALPHA_NUMERIC'), // 只能輸入英文字母和數字或底線
          (v) => (v.length <= 30) || i18n.t('RULE.RULE_30')  // 最多 30 個字
        ],
        descriptionRules: [
          (v) => !!v || i18n.t('RULE.RULE_R'),
          (v) => /^.{0,100}$/s.test(v) || i18n.t('RULE.RULE_100')
        ],
        categoryRules: [
          (v) => !!v || i18n.t('RULE.RULE_R'),
          (v) => /^.{0,30}$/.test(v) || i18n.t('RULE.RULE_30')
        ],
      },
      user_list: [],
      upgpt_group_list: [],
      default_manager_access_option: true,
      default_viewer_access_option: true,
      MUData: [],
      MGData: [],
      VUData: [],
      VGData: [],
       // //- 每次更動的比對值
      com_manager_access_option:true,
      com_viewer_access_option:true,
      compareMUData:[],
      compareMGData:[],
      compareVUData:[],
      compareVGData:[],
      // //- 取消更新時的復原值
      ori_manager_access_option:true,
      ori_viewer_access_option:true,
      originalMUData:[],
      originalMGData:[],
      originalVUData:[],
      originalVGData:[],
      //- Dialog
      messageDialog: false,
      message: "",
      errorDialog: false,
      errorMessage: "",
      folderPickerDialog: false,
    }
  },
  async created() {

  },
  methods: {
    validateForm() {
      return !!this.$refs.form.validate();
    },
    onCancel() {     
      this.$emit("emitAddFolderDialog", false);
    },
    onConfirm(){
      if (this.validateForm() && !this.addBtn_loading) {
        this.$emit("emitAddFolderDialog", this.addFolderData);
      }
    },
    toggleManagerAccessOption(){
      if(this.default_manager_access_option){
        this.MUData = [];
        this.MGData = [];
      }
    },
    toggleViewerAccessOption(){
      if(this.default_viewer_access_option){
          this.VUData = [];
          this.VGData = [];
      }
    },
    checkAll(selected_option, option_list){
      return selected_option.length === option_list.length
    },
    checksome(selected_option, option_list){
      return selected_option.length > 0 && !this.checkAll(selected_option, option_list)
    },
    icon(selected_option, option_list){
      if (this.checkAll(selected_option, option_list)){
          return 'mdi-close-box'
      }else if(this.checksome(selected_option, option_list)){
            return 'mdi-minus-box'
      }else{
          return 'mdi-checkbox-blank-outline'
      }
    },
    onFolderPickerCancel() {
      this.folderPickerDialog = false;
    },
    onFolderPickerConfirm({ id, parent_folder, path }) {
      this.addFolderData.parent_id = id;   // 回填選到的位置 id
      this.addFolderData.parent_folder = parent_folder;
      this.addFolderData.path = path;
      this.folderPickerDialog = false;
    },
    onEmitMessageDialog() { 
      this.messageDialog = false;
    },
    onEmitErrorDialog() {
      this.errorDialog = false;
    },
    openFolderPick(){
      this.folderPickerDialog = true;
    },
    // onPathFieldClick(){
    //   if (!this.addFolderData.path) {
    //     this.openFolderPick();
    //   }
    // }
  }
})
</script>
<style scoped>

</style>